<template>
  <div class="app_wrap">
    <div class="bg"></div>
    <div class="slideArea">
      <p class="text">请您完成以下验证，验证成功后可继续探索小猪。</p>
      <safeVerify
        class="safeCheck"
        ref="netEaseVerify"
        :checkPass="checkPass()"
        v-if="checkType === 'yidun'"
      ></safeVerify>
    </div>
  </div>
</template>
<script>
import { GetSlideVerifyType } from "../service/getData";
import safeVerify from "./safeVerify/safeVerify";
import { Toast } from "mint-ui";
export default {
  data() {
    return {
      checkType: "",
    };
  },
  components: {
    safeVerify,
  },
  methods: {
    checkPass() {
      // this.$store.commit('needsCheck',false)
    },
  },
};
</script>
<style scoped>
.app_wrap {
  width: 100vw;
  height: 100vh;
  position: fixed !important;
  left: 0px;
  top: 0px;
  z-index: 10000;
}
.bg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0px;
  top: 0px;
  background-color: #000000;
  opacity: 0.6;
}
.slideArea {
  width: 80%;
  margin: 0 auto;
  background-color: #ffffff;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 20px;
  z-index: 10001;
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
}
.text {
  font-size: 14px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/avoidSpider.vue